import React from "react";
import { FaCalendarDay } from "react-icons/fa";
import Loader from "../../../components/Loader/Loader";
import StatusChip from "../../../components/StatusChip/StatusChip";
import { useStudentEvents } from "./hooks/useStudentEvents";
import { isHolidayEvent } from "../utils/studentEventUtils";
import { sanitizeHtml } from "../../../utils/sanitizeHtml";
import "./StudentEvents.css";

// event_date is either a single date ("2027-03-26") or a range string
// ("2026-12-31 to 2027-01-08") — show the full range when there is one.
const formatEventDate = (value) => {
  if (!value) return "";
  const formatOne = (raw) => {
    const date = new Date(raw);
    if (Number.isNaN(date.getTime())) return raw;
    return date.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  };
  const [start, end] = String(value).split(" to ").map((part) => part.trim());
  return end ? `${formatOne(start)} - ${formatOne(end)}` : formatOne(start);
};

const StudentEvents = () => {
  const { events, isLoading } = useStudentEvents();

  return (
    <div className="student-events">
      <h5 className="sp-section-title">Events</h5>

      {isLoading ? (
        <Loader />
      ) : events.length === 0 ? (
        <div className="sp-card student-events-empty text-center">
          <span className="sp-icon-tile">
            <FaCalendarDay size={18} />
          </span>
          <p className="mb-0 text-muted">No events have been published yet.</p>
        </div>
      ) : (
        <div className="student-events-list">
          {events.map((event, index) => {
            const title = event?.title || event?.name || "Event";
            const description = event?.description || event?.details || "";
            const isHoliday = isHolidayEvent(event);
            const key = event?.id ?? index;

            return (
              <div key={key} className="sp-card student-events-card">
                <div className="student-events-head">
                  <h6 className="student-events-title">{title}</h6>
                  <StatusChip tone={isHoliday ? "danger" : "info"}>{isHoliday ? "Holiday" : "Event"}</StatusChip>
                </div>
                <p className="student-events-date text-muted mb-1">{formatEventDate(event?.event_date)}</p>
                {description && (
                  <div
                    className="student-events-desc text-muted"
                    // eslint-disable-next-line react/no-danger -- sanitized via DOMPurify in sanitizeHtml() above
                    dangerouslySetInnerHTML={{ __html: sanitizeHtml(description) }}
                  />
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default StudentEvents;
